import { render, staticRenderFns } from "./BuildGrid.vue?vue&type=template&id=c39c063e&"
import script from "./BuildGrid.vue?vue&type=script&lang=js&"
export * from "./BuildGrid.vue?vue&type=script&lang=js&"
import style0 from "./BuildGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports